<sky-swipe-controller
  *ngIf="options.hideBySwipe; else content"
  [allowSwipeLeft]="true"
  [allowSwipeRight]="true"
  [swipeDistance]="50"
  (swiped)="hide()"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</sky-swipe-controller>
<ng-template #content>
  <div
    *ngIf="visibilityValue$ | async as visibility"
    class="root"
    [ngClass]="['-position-' + position]"
    [style.max-width]="options.maxWidth"
    [@visibility]="{
      value: visibility,
      params: {
        showTransform: getShowAnimationTransform(),
        hideTransform: getHideAnimationTransform()
      }
    }"
    (@visibility.done)="onVisibilityAnimationDone()"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <ng-container *ngIf="options.contentRef">
      <ng-container
        *ngTemplateOutlet="options.contentRef; context: options.contentRefContext"
      ></ng-container>
    </ng-container>

    <ng-container *ngIf="!options.contentRef">
      <div *ngIf="options.title" class="title" [innerHTML]="options.title"></div>

      <div class="content" [innerHTML]="options.content"></div>
    </ng-container>
  </div>
</ng-template>
